import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useAuthStore } from '@/store/useAuthStore';
import { startOpenTabTracking, touchOpenTab } from '@/utils/openTabRegistry';

const currentPath = () => {
  if (typeof window === 'undefined') return '';
  return `${window.location.pathname}${window.location.search}`;
};

const readTabMeta = (path: string) => {
  const rawTitle = typeof document !== 'undefined' ? document.title.trim() : '';
  const title = rawTitle.replace(/\s*[-|]\s*TOPPION(?:\s+Holdings)?\s*$/i, '').trim();
  return {
    title: title || path,
    path,
  };
};

/** Giữ một khóa cho tab hiện tại để các tab khác của cùng user đếm được. */
export function OpenTabTracker() {
  const userId = useAuthStore((state) => state.profile?.id || '');
  const router = useRouter();
  const metaRef = useRef(readTabMeta(currentPath() || router.asPath));
  metaRef.current = readTabMeta(currentPath() || router.asPath);

  useEffect(() => {
    if (!userId) return undefined;
    return startOpenTabTracking({
      userId,
      getMeta: () => metaRef.current,
    });
  }, [userId]);

  useEffect(() => {
    const sync = () => {
      metaRef.current = readTabMeta(currentPath());
      touchOpenTab();
    };
    const onRoute = () => {
      sync();
      window.setTimeout(sync, 400);
    };
    sync();
    router.events.on('routeChangeComplete', onRoute);
    return () => {
      router.events.off('routeChangeComplete', onRoute);
    };
  }, [router.events]);

  return null;
}
